import "./BookingCards.css";

export default function BookingCards({ heading, cardStyle, headingStyle, children, ...rest }: any) {
  return (
    <div className="booking-card" {...rest}>
      <h3 className="cardStyle" style={{...cardStyle, ...headingStyle}}>{heading}</h3>
      {children}
    </div>
  );
}